import { ReactComponent as LogoSvg } from '@cobliteam/base-components/src/icons/logo-primary-horizontal.svg';
import type { SessionUser } from '@cobliteam/common-types';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import InsightsButton from '@cobliteam/insights';
import { lazy } from '@cobliteam/lazy-with-retries';
import { SidebarTrigger } from '@cobliteam/ui-business/components/AppSidebar';
import AppUserButton from '@cobliteam/ui-business/components/AppUserButton';
import Divider from '@cobliteam/ui/components/Divider';
import { InputSearch } from '@cobliteam/ui/form';
import { Suspense } from 'react';
import { Link, useHistory } from 'react-router-dom';
import FeedbackButton from './components/FeedbackButton';
import HowToUseButton from './components/HowToUseButton';
import NotificationsButton from './components/NotificationsButton';

const GlobalSearch = lazy(() => import('@cobliteam/global-search'));

const AppHeader = ({ user, logout }: { user: SessionUser; logout: () => void }) => {
  const { coblinator } = useFeatureFlags();
  const history = useHistory();

  const onClickLogo = () => history.push('/');

  return (
    <header data-testid='app-header' className='top-0 flex h-14 items-center justify-between gap-2 border-gray-6 border-b px-2 pl-4'>
      <div className='flex w-full items-center gap-2'>
        <SidebarTrigger className='-ml-1' />
        <Divider orientation='vertical' className='mx-2 h-4' />
        <Link to='/' onClick={onClickLogo}>
          <LogoSvg className='h-7' />
        </Link>
      </div>
      <div className='flex items-center justify-end gap-2.5 '>
        <Suspense fallback={<InputSearch size='sm' className='w-[300px]' onChange={() => {}} placeholder='Carregando...' disabled />}>
          <GlobalSearch />
        </Suspense>
        {coblinator ? <InsightsButton /> : null}
        <NotificationsButton />
        <FeedbackButton />
        <HowToUseButton />
        <AppUserButton user={user} logout={logout} />
      </div>
    </header>
  );
};

export default AppHeader;
